import "./QuestionYesNo.css";
import CustomCheckBox from "../../Components/custom-checkbox/CustomCheckBox";
import { t } from "i18next";

const QuestionDetailsYesNoAnswerWidget = ({ question, setQuestion, isMobile }) => {
  const handleChange = (flagValue) => {
    setQuestion({ ...question, flag: flagValue });
  };

  return (
    <div className="survey-container">
      <div className="question-group">
        <div
          className="question-text"
          style={{ backgroundColor: "transparent" }}
        ></div>
        {
          isMobile ?
          <></>
          :
          <div className="options-question">
            <label className="checkbox-label container-checkbox-label-agree">
              {t("yes")}
            </label>
            <label className="checkbox-label container-checkbox-label-disagree">
              {t("no")}
            </label>
          </div>
        }
        
      </div>
      <div key={question.id} className="question-group">
        <div className="question-text">
          {question.text}
          <ul>
            {question.details && question.details.map((item, index) => {
              return  <li style={{listStyleType:"disc"}} key={index}>
                        {item}
                      </li>;
            })}
          </ul>
        </div>
        <div className="options-question">
          {
            isMobile ?
            <>
            <CustomCheckBox
            value={question.flag === true}
            setValue={() => handleChange(true)}
            text={t("yes")}
          />
          <CustomCheckBox
            value={question.flag === false}
            setValue={() => handleChange(false)}
            text={t("no")}
          />
            </>
            :
            <>
            <CustomCheckBox
            value={question.flag === true}
            setValue={() => handleChange(true)}
            text={""}
          />
          <CustomCheckBox
            value={question.flag === false}
            setValue={() => handleChange(false)}
            text={""}
          />
            </>
          }
          
        </div>
      </div>
    </div>
  );
};
export default QuestionDetailsYesNoAnswerWidget;
